module.exports = __webpack_public_path__ + "img/image23.ad2e48ed.png";